import { render, staticRenderFns } from "./logisticsDialog.vue?vue&type=template&id=9d26c460&scoped=true&"
import script from "./logisticsDialog.vue?vue&type=script&lang=js&"
export * from "./logisticsDialog.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDialog.vue?vue&type=style&index=0&id=9d26c460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d26c460",
  null
  
)

export default component.exports